<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <hint :value="inputHint" />
    <label for="terminal-id-select" class="control-label">{{ inputLabel }}</label>
    <select
      v-model="inputValue"
      :title="title"
      :disabled="disabled"
      id="terminal-id-select"
      class="form-control"
      @input="emit"
      @change="emit"
      @blur="emit"
    >
      <option v-for="item in sortedItems" :key="item.id" :value="item.id">{{ item.name }}</option>
    </select>
    <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import passSectionMixin from '../../../../mixins/application-form/passSectionMixin'
import passInputMixin from '../../../../mixins/application-form/passInputMixin'
import Hint from '@/common/components/inputs/components/Hint.vue'

export default {
  name: 'TerminalIdInput',

  components: { Hint },

  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    passSectionMixin,
    passInputMixin
  ],

  props: {
    inputLabel: {
      default: 'Терминал'
    },

    inputName: {
      default: 'terminal_id'
    },

    inputHint: {
      default: undefined
    },

    items: {
      type: [Array, Object],
      default: () => []
    },

    typeaheadData: {
      type: Array,
      default: () => []
    }
  },

  created() {
    if (this.sortedItems.length === 1) {
      this.inputValue = this.sortedItems[0].id
    }
  },

  computed: {
    title() {
      return this.items[this.inputValue]?.name
    },

    sortedItems() {
      return (Object.values(this.items).sort((a, b) => a.sort - b.sort))
    }
  },

  watch: {
    sortedItems(value) {
      if (value.length === 1) {
        this.inputValue = value?.[0]?.id
      }
    }
  }
}
</script>
